var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.id ? "修改核销员" : "添加核销员",
            visible: _vm.dialogFormVisible,
            width: "540px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.cancel,
          },
          model: {
            value: _vm.dialogFormVisible,
            callback: function ($$v) {
              _vm.dialogFormVisible = $$v
            },
            expression: "dialogFormVisible",
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "90px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "核销员：", prop: "uid" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row row-middle" },
                    [
                      _vm.ruleForm.uid
                        ? _c("span", { staticClass: "mr10 clerk-selected" }, [
                            _vm._v(
                              _vm._s(_vm.selectedName) +
                                "（ID:" +
                                _vm._s(_vm.ruleForm.uid) +
                                "）"
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.openClerkDialog },
                        },
                        [_vm._v("选择核销员")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属提货点：", prop: "storeId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.ruleForm.storeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "storeId", $$v)
                        },
                        expression: "ruleForm.storeId",
                      },
                    },
                    _vm._l(_vm.storeSelectList, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#8492a6",
                                "font-size": "13px",
                              },
                            },
                            [_vm._v(_vm._s(item.promoterName))]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "核销员名称：" } },
                [
                  _c("el-input", {
                    staticClass: "dialogWidth",
                    attrs: { placeholder: "请输入核销员名称" },
                    model: {
                      value: _vm.ruleForm.staffName,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "staffName", $$v)
                      },
                      expression: "ruleForm.staffName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号码：" } },
                [
                  _c("el-input", {
                    staticClass: "dialogWidth",
                    attrs: { placeholder: "请输入手机号码" },
                    model: {
                      value: _vm.ruleForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "phone", $$v)
                      },
                      expression: "ruleForm.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "核销权限：" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "开启",
                      "inactive-text": "关闭",
                    },
                    model: {
                      value: _vm.ruleForm.verifyStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "verifyStatus", $$v)
                      },
                      expression: "ruleForm.verifyStatus",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
              _vm.id
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:system:staff:update"],
                          expression: "['admin:system:staff:update']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.editForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("修改")]
                  )
                : _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:system:staff:save"],
                          expression: "['admin:system:staff:save']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择核销员",
            visible: _vm.clerkDialog,
            width: "900px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.clerkDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户搜索：" } },
                [
                  _c("UserSearchInput", {
                    on: { searchList: _vm.clerkSearch },
                    model: {
                      value: _vm.clerkFrom,
                      callback: function ($$v) {
                        _vm.clerkFrom = $$v
                      },
                      expression: "clerkFrom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.clerkSearch },
                },
                [_vm._v("搜索")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "ml10",
                  attrs: { size: "small" },
                  on: { click: _vm.resetClerkSearch },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.clerkLoading,
                  expression: "clerkLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.clerkList, size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { width: "155", label: "ID" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-radio", {
                          attrs: { label: scope.row.uid },
                          on: {
                            change: function () {
                              return _vm.selectClerkRow(scope.row)
                            },
                          },
                          model: {
                            value: _vm.clerkRadio,
                            callback: function ($$v) {
                              _vm.clerkRadio = $$v
                            },
                            expression: "clerkRadio",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "头像", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "36px", height: "36px" },
                          attrs: {
                            src: scope.row.avatar,
                            "preview-src-list": [scope.row.avatar],
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "nickname", label: "姓名", "min-width": "160" },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", "min-width": "140" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "acea-row row-right mt20" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.clerkFrom.limit,
                  "current-page": _vm.clerkFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.clerkTotal,
                },
                on: {
                  "size-change": _vm.clerkSizeChange,
                  "current-change": _vm.clerkPageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.clerkDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmClerk } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }